/* Youtube Box Widget Script
 * - Steve Graboski, MU 2018
 * */

/* helper classes */
function addClass(el, classname) {
    el.className += " " + classname;
}
function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

/* Global Vars */
// grab all youtube boxes on the current page's html
var youtubeboxes = document.querySelectorAll('.youtubebox')
// empty array to access the JS yt players generated by this script
var ytPlayers = [];
// counter to make sure we only attach event handlers one time
ytInitCounter = false;

/* Main Function */
// executes once the youtube Iframe API is ready
function onYouTubeIframeAPIReady() {
    // create a youtube player for each youtubebox in the html
    for (var i = 0; i < youtubeboxes.length; i++) {
        var playerId = youtubeboxes[i].getAttribute('data-iframeId');
        var autoplay = youtubeboxes[i].getAttribute('data-autoplay');
        var loop = youtubeboxes[i].getAttribute('data-loop');
        var controls = youtubeboxes[i].getAttribute('data-controls');
        var title = youtubeboxes[i].querySelector('h3');
        var playerVars = {showinfo: false,
            wmode: "opaque",
            rel: 0,
            enablejsapi: 1,
            autoplay: (autoplay) ? 1 : 0,
            autohide: (autoplay) ? 1 : 0, 
            loop: (loop) ? 1 : 0,
            controls: (controls) ? 0 : 1,
        }
        if (loop) {
            playerVars.playlist = youtubeboxes[i].getAttribute('data-video');
        }
        (function (i) {
            return ytPlayers.push(new YT.Player(playerId, {
                videoId: youtubeboxes[i].getAttribute('data-video'),
                playerVars: playerVars,
                events: {
                    // Run event handlers once youtube api finishes creating the players
                    onReady: ytInit,
                    // make sure the overlay is gone once the video starts loading 
                    onStateChange: function (e) {
                        // ignore this if we want the overlay to stay
                        if (youtubeboxes[i].getAttribute('data-permoverlay')) {
                            return;
                        }
                        // (e.data == -1 in YT speak for "check that the video is loading")
                        if (e.data == -1 && !hasClass(youtubeboxes[i], 'active')) {
                            addClass(youtubeboxes[i], 'active');
                        }
                    }
                }
            }));
        })(i);
        // after creating the player, remove frameborder from the iframe
        var curIframe = document.getElementById(playerId);
        curIframe.removeAttribute('frameborder');
        curIframe.removeAttribute('width');
        curIframe.removeAttribute('height');
        if (title) {
            curIframe.setAttribute('title', title.innerText);
        } 
    }
}

/* Event Handlers */
// attach click events to each youtube player
function ytInit() {
    if (!ytInitCounter) {
        for (var i = 0; i < ytPlayers.length; i++) {
            if (youtubeboxes[i].getAttribute('data-autoplay')) {
                ytPlayers[i].setVolume(0);
            }
            youtubeboxes[i].addEventListener('click', (function (i) {
                // Click event only needed if no custom image. 
                // Otherwise we let the iframe initiate youtube playback.
                return function () {
                    // when clicked, check if our player has a custom image
                    if (hasClass(youtubeboxes[i], 'withImage') && !hasClass(youtubeboxes[i], 'active')) {
                        // if so, remove it on click and then play the video
                        addClass(youtubeboxes[i], 'active');
                        ytPlayers[i].playVideo();
                    }
                }
            })(i));
        }
    }
    ytInitCounter = true;
}